import React from 'react'
import type { LineItemCellProps } from '../types/financials.types'

export const LineItemCell: React.FC<LineItemCellProps> = ({
	lineItem,
	isDefault,
	isDraggable,
	onDelete,
	onDragStart,
	onDragEnd,
}) => {
	const [isDragging, setIsDragging] = React.useState(false)

	const handleDragStart = (e: React.DragEvent) => {
		setIsDragging(true)
		e.dataTransfer.effectAllowed = 'move'
		e.dataTransfer.setData('lineItemId', lineItem.id)
		onDragStart?.()
	}

	const handleDragEnd = () => {
		setIsDragging(false)
		onDragEnd?.()
	}

	return (
		<td
			className={`
				px-3 py-2 text-left font-medium text-gray-900 border-r border-b border-gray-300 bg-white
				${isDragging ? 'opacity-50' : ''}
			`}
			draggable={isDraggable}
			onDragStart={handleDragStart}
			onDragEnd={handleDragEnd}
			role="gridcell"
		>
			<div className="flex items-center justify-between group">
				<div className="flex items-center space-x-2">
					{isDraggable && (
						<span
							className="text-gray-400 group-hover:text-gray-600 cursor-move"
							title="Drag to reorder"
							aria-label="Drag handle"
						>
							<svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
								<path d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z" />
							</svg>
						</span>
					)}
					<span className={lineItem.type === 'calculated' ? 'italic' : ''}>{lineItem.label}</span>
					{lineItem.description && (
						<span
							className="text-gray-400 hover:text-gray-600"
							title={lineItem.description}
							aria-label={lineItem.description}
						>
							<svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
								<path
									fillRule="evenodd"
									d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
									clipRule="evenodd"
								/>
							</svg>
						</span>
					)}
				</div>
				{!isDefault && onDelete && (
					<button
						onClick={onDelete}
						className="opacity-0 group-hover:opacity-100 text-gray-400 hover:text-red-600 transition-opacity focus:opacity-100"
						aria-label={`Delete ${lineItem.label}`}
						title="Delete line item"
					>
						<svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
							<path
								fillRule="evenodd"
								d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z"
								clipRule="evenodd"
							/>
						</svg>
					</button>
				)}
			</div>
		</td>
	)
}

